export class ReportDiffCountMap {
  constructor(private readonly high: number, private readonly medium: number, private readonly low: number, private readonly passed: number) {}

  getHigh() {
    return this.high;
  }

  getMedium() {
    return this.medium;
  }

  getLow() {
    return this.low;
  }

  getPassed() {
    return this.passed;
  }

  getFailed() {
    return this.low + this.medium + this.high;
  }

  getTotal() {
    return this.getFailed() + this.getPassed();
  }
}
